// @ts-nocheck

/**
 * * `image` - Image
 * `text` - Text
 * `shape` - Shape
 */
export type LayerTypeEnum = typeof LayerTypeEnum[keyof typeof LayerTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LayerTypeEnum = {
  image: "image",
  text: "text",
  shape: "shape",
} as const;
